import { Lock } from "lucide-react";
import { Button } from "../ui/button";
import { formatCurrency } from "@nusrif/utils";
import config from "@nusrif/config";
interface PaymentButtonProps {
  total: number;
  onPayment: () => void;
  isProcessing: boolean;
  paymentMethod: string;
}
export const PaymentButton = ({ total, onPayment, isProcessing, paymentMethod }: PaymentButtonProps) => {
  const getButtonText = () => {
    if (isProcessing) return 'Processing...';
    if (paymentMethod === 'cod') return 'Place Order';
    return 'Pay Now';
  };
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-5 py-4 z-50">
      <div className="space-y-4">
        {/* Security Notice */}
        <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
          <Lock className="w-4 h-4" />
          <span>Your payment information is secure and encrypted</span>
        </div>
        {/* Total Amount Display */}
        <div className="flex items-center justify-between">
          <span className="text-lg font-medium text-black">
            Total Amount
          </span>
          <span className="text-xl font-bold text-black">
            {formatCurrency(total, config.region.currencyCode)}
          </span>
        </div>
        
        {/* Payment Button */}
        <Button
          onClick={onPayment}
          disabled={isProcessing}
          className="w-full h-14 text-lg font-semibold rounded-full disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isProcessing ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <Lock className="w-5 h-5" />
              {getButtonText()}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};